import React from "react";
import { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import AddIcon from "../../../../components/icon/icons/layer-22-icon.component";
import { Grid } from "@material-ui/core";
import { NewExecutionBriefModal } from "../../../../components/modals/new-execution-brief-modal/new-execution-brief-modal.component";
import {
  selectExecutionBriefsInCampaignResults,
  selectExecutionBriefLoader,
  selectExecutionBriefsErrors,
} from "../../../../redux/selectors/executionBriefs";
import {
  getExecutionBriefsInCampaign,
  saveExecutionBrief,
} from "../../../../redux/actions/executionBriefListActions";
import moment from "moment";
import { BriefType } from "../../../../constants/types";
import { BriefListTable } from "../../../../features/brief-list/components/brief-list-table/brief-list-table.component";
import { TExecutionBriefResults } from "../../../../redux/reducers/executionBriefsReducer";
import usePermissions from "../../../../hooks/usePermissions";
import { SpinnerLoader } from "../../../../components/loaders";
import { BorderedBlock } from "../../../../features/common-attributes/components/bordered-block/bordered-block.component";
import { OutlinedButton } from "../../../../components/form-controls/button/outlined-button/outlined-button.component";
import { ExecutionBriefProps } from "../../../../features/brief-list/types/props/execution-brief.props";
import { HiddenHeading } from "../../../pages.styles";
import * as store from "../../store/campaign-brief.store";

export interface ExecutionBriefTabProps {
  pageTitle?: string;
}

export const ExecutionBriefTab = (props: ExecutionBriefTabProps) => {
  const userPermissions = usePermissions();
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = useSelector(selectExecutionBriefLoader);
  const [newExecutionBriefModalOpen, setNewExecutionBriefModalOpen] = useState<boolean>(false);

  const { id: campaignBriefId } = useParams<{ id: string }>();

  useEffect(() => {
    if (campaignBriefId) {
      dispatch(getExecutionBriefsInCampaign(campaignBriefId));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [campaignBriefId]);

  const campaignBriefName = useSelector(store.getName);
  const newExecutionBriefModalErrors = useSelector(selectExecutionBriefsErrors);

  const executionBriefs = useSelector(selectExecutionBriefsInCampaignResults);

  const convertData = (origData?: TExecutionBriefResults[]): ExecutionBriefProps[] => {
    if (origData) {
      return origData.map((item) => ({
        ...item,
        ownerName: `${item.briefOwner.firstName} ${item.briefOwner.lastName}`,
        date: moment(item.createdAt).format("MMM DD"),
        createdDate: moment(item.createdAt).format("YYYY-MM-DD"),
      }));
    } else {
      return [];
    }
  };

  const dataList = convertData(executionBriefs);
  const sortedDataList = dataList.sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1)); // Sorted by created datetime descending

  const onCreateExecutionBrief = (data: any) => {
    dispatch(saveExecutionBrief(data, history));
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <HiddenHeading>{props.pageTitle}</HiddenHeading>
        <BorderedBlock>
          {sortedDataList && sortedDataList.length > 0 && (
            <BriefListTable dataList={sortedDataList} briefType={BriefType.EXECUTION_BRIEF} />
          )}
          <OutlinedButton
            disabled={!userPermissions.manageExecBriefs}
            onClick={() => setNewExecutionBriefModalOpen(true)}
            variant={"outlined"}
            startIcon={<AddIcon />}
          >
            Add Multi Channel Brief
          </OutlinedButton>
        </BorderedBlock>
        <SpinnerLoader showIf={isLoading.status === "loading"} innerLoader={true} />
      </Grid>
      <NewExecutionBriefModal
        campaignId={campaignBriefId}
        campaignName={campaignBriefName}
        errors={newExecutionBriefModalErrors}
        isOpen={newExecutionBriefModalOpen}
        onClose={() => setNewExecutionBriefModalOpen(false)}
        onSubmit={onCreateExecutionBrief}
      />
    </Grid>
  );
};
